import { createFileRoute } from "@tanstack/react-router";
import { Shield } from "lucide-react";

import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { PageHeader } from "@/components/layout/heading";
import { ReviewQueue } from "@/components/ai-consumer-research/brand-moderator/review-queue";
import { ActionHistory } from "@/components/ai-consumer-research/brand-moderator/action-history";

import { RulesEngine } from "@/components/ai-consumer-research/brand-moderator/rules-engine";
import { ResponsePlaybook } from "@/components/ai-consumer-research/brand-moderator/response-playbook";
import { useModerationStore, type BrandModeratorTab } from "@/store/moderation";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/brand-moderator")({
  component: BrandModerator,
});

const sections: { id: string; label: string; countId?: string }[] = [
  { id: "review-queue", label: "Review Queue", countId: "needs_review" },
  { id: "rules-engine", label: "Rules Engine" },
  { id: "response-playbook", label: "Response Playbook" },
  { id: "action-history", label: "Action History" },
];

export function BrandModerator() {
  const brandModeratorTab = useModerationStore((s) => s.brandModeratorTab);
  const setBrandModeratorTab = useModerationStore((s) => s.setBrandModeratorTab);

  return (
    <div className="space-y-6">
      <Tabs value={brandModeratorTab} onValueChange={(v) => setBrandModeratorTab(v as BrandModeratorTab)}>
        <PageHeader
          title={
            <div className="flex items-center gap-2">
              <Shield size={20} className="text-muted-foreground shrink-0" />
              Brand Moderator
              <Badge className="rounded-md bg-success/10 text-xs text-success font-semibold px-2 py-0.5">AGENT</Badge>
            </div>
          }
          description="AI-powered response generation and comment moderation across all channels"
          className="flex flex-col gap-4"
        >
          <div className="overflow-x-auto scrollbar-hidden">
            <TabsList className="bg-transparent gap-2 p-0 flex-nowrap mx-auto w-fit">
              {sections.map(({ id, label }) => (
                <TabsTrigger
                  key={id}
                  value={id}
                  className="rounded-full border border-border bg-background px-4 py-2 text-sm font-medium text-muted-foreground data-[state=active]:bg-foreground dark:data-[state=active]:bg-foreground data-[state=active]:text-background  data-[state=active]:border-foreground data-[state=active]:shadow-none whitespace-nowrap"
                >
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>
          </div>
        </PageHeader>

        <TabsContent value="review-queue" className="mt-6">
          <ReviewQueue />
        </TabsContent>
        <TabsContent value="rules-engine" className="mt-6">
          <RulesEngine />
        </TabsContent>
        <TabsContent value="response-playbook" className="mt-6">
          <ResponsePlaybook />
        </TabsContent>
        <TabsContent value="action-history" className="mt-6">
          <ActionHistory />
        </TabsContent>
      </Tabs>
    </div>
  );
}
